import script from "./ExternalInspectionAnswerIssues.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExternalInspectionAnswerIssues.vue?vue&type=script&lang=ts&setup=true"

import "./ExternalInspectionAnswerIssues.vue?vue&type=style&index=0&id=ec425bfe&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec425bfe"]])

export default __exports__